import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Button
} from "./UI";
import { MaterialLibrarySection } from "./MaterialLibrarySection";
import { LibraryBig, FileText, FileSpreadsheet, ArrowLeft } from "lucide-react";

const libraries = [
  {
    id: "material",
    title: "Material Library",
    description: "Manage organization-level material master",
    icon: LibraryBig,
  },
  {
    id: "quotation",
    title: "Quotation Templates",
    description: "Manage standardized quotation templates",
    icon: FileText,
  },
  {
    id: "boq",
    title: "BOQ Templates",
    description: "Manage bill of quantities templates",
    icon: FileSpreadsheet,
  }
];

export function OrganizationLibrarySection({ setHideSidebar }) {
  const [activeLibrary, setActiveLibrary] = useState(null);

  useEffect(() => {
    if (setHideSidebar) {
      setHideSidebar(!!activeLibrary);
    }
    // Cleanup when component unmounts
    return () => {
      if (setHideSidebar) {
        setHideSidebar(false);
      }
    };
  }, [activeLibrary, setHideSidebar]);

  if (activeLibrary === "material") {
    return (
      <div className="space-y-2">
        <Button variant="ghost" className="gap-2 -ml-2 text-text-gray" onClick={() => setActiveLibrary(null)}>
          <ArrowLeft className="h-4 w-4" />
          Back to Libraries
        </Button>
        <MaterialLibrarySection />
      </div>
    );
  }

  // Fallback for other libraries that are not implemented yet
  if (activeLibrary) {
    return (
      <div className="space-y-4 pb-6">
        <Button variant="ghost" className="gap-2 -ml-2 text-text-gray" onClick={() => setActiveLibrary(null)}>
          <ArrowLeft className="h-4 w-4" />
          Back to Libraries
        </Button>
        <div className="flex items-center justify-center p-12 border rounded-lg border-dashed mt-4 bg-gray-50/50">
             <p className="text-text-gray">This library is under construction.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 pb-6">
      <div>
        <h2 className="text-2xl font-semibold text-primary-text">Organization Library</h2>
        <p className="text-text-gray mt-1">Manage all organization repositories and templates.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {libraries.map((lib) => (
          <Card 
            key={lib.id} 
            className="cursor-pointer hover:border-sm-primary transition-colors border-sm-border/50 shadow-sm"
            onClick={() => setActiveLibrary(lib.id)}
          >
            <CardHeader className="pb-3">
              <div className="w-10 h-10 rounded-lg bg-sm-primary/10 flex items-center justify-center mb-3">
                <lib.icon className="h-5 w-5 text-sm-primary" />
              </div>
              <CardTitle className="text-lg">{lib.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm">
                {lib.description}
              </CardDescription>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
